/* tslint:disable:max-line-length */
export default {
	/* Registration */
	buy_property: {
		en: "purchase, acquisition, investment, deal",
		ar: "شراء ، استثمار ، صفقة",
	},
	project_status: {
		en: "condition, position, state, project",
		ar: "الشرط ، الموقف ، حالة، مشروع",
	},
	ownership_certificate: {
		en: "authentication, documents, evidence, facts, information, substantiation",
		ar: "مصادقة ، الوثائق ، الأدلة ، الحقائق ، المعلومات ، الإثبات",
	},
	twimc: {
		en: "authentication, authorization, certification, paper, documentation, permit, deed",
		ar: "مصادقة ، إذن ، شهادة ، ورقة ، وثائق ، تصريح ، صك",
	},
	myrequest: {
		en: "",
		ar: "",
	},
	svc_catalogue: {
		en: "archive, catalog, directory, inventory, prospectus, list",
		ar: "الأرشيف ، كتالوج ، دليل ، جرد ، نشرة ، قائمة",
	},
	procedure_status_enquiry: {
		en: "condition, position, state, request",
		ar: "الشرط ، الموقف ، حالة، طلب",
	},
	transactions: {
		en: "action, activity, affair, bond, business, deal, purchase, sale, selling, mortgage",
		ar: "العمل ، النشاط ، القضية ، السندات ، العمل ، الصفقة ، الشراء ، البيع ، البيع ، الرهن العقاري",
	},
	procedure_fee_calculator: {
		en: "account, bill, cost,  expense, pay, payment, price, wage",
		ar: "حساب ، فاتورة ، تكلفة ، حساب ، دفع ، دفعه ، سعر ، أجر",
	},
	owner_regi: {
		en: "Register, registration, recording, record,  enrollment, account",
		ar: "تسجيل، حساب، فتح حساب، تسجيل حساب",
	},
	verify_valuation_certificate: {
		en: "condition, position, state, assessment, cost, estimate, estimation, worth",
		ar: "الشرط ، الموقف ، حالة، تقدير ، تكلفة ، تقييم ، قيمة",
	},
	listings: {
		en: "List, Listing, Sell, Rent, Lease",
		ar: "عرض عقار، بيع، تأجير",
	},
	my_listings: {
		en: "List, Listing, Sell, Rent, Lease",
		ar: "عرض عقار، بيع، تأجير",
	},
	land_status: {
		en: "land, plot, piece, lot, parcel, tract, status, situation, position, placement, positioning, posture",
		ar: "أرض ، قطعة أرض ، قطعة ، وضع، حالة، موقف",
	},
	/*RERA*/
	legislation: {
		en: "law, rules, ruling, regulations, acts, bills, statutes, enactments, ordinances, permits, licenses",
		ar: "القانون ، القواعد ، الحكم ، اللوائح ، الأفعال ، الفواتير ، القوانين ، التشريعات ، المراسيم، التصاريح، التراخيص",
	},
	rental_index: {
		en: "indicator, ratio, basis, clue, guide, pointer, indicia, renting, lease, permits, licenses",
		ar: "مؤشر ، نسبة ، أساس ، دليل، تأجير، إيجار، التصاريح، التراخيص",
	},
	dubai_brokers: {
		en: "agent, dealer, entrepreneur, financial, intermediary, mediator, merchant, stockbroker, permits, licenses",
		ar: "وكيل ، تاجر ، رجل أعمال ، مالي ، وسيط ، سمسار، التصاريح، التراخيص",
	},
	e_card: {
		en: "badge, check, label, poster, ticket, authentication, documents, evidence, facts, information, substantiation, permits, licenses",
		ar: "شارة ، تحقق ، التسمية ، ملصق ، تذكرة، مصادقة ، إذن ، شهادة ، ورقة ، وثائق ، تصريح ، صك، التصاريح، التراخيص",
	},
	search_trade_license: {
		en: "authorization, certificate, charter, permit, privilege, examination, exploration, inquiry, inspection, investigation, pursuit, quest, research, licenses",
		ar: "إذن ، شهادة ، ميثاق ، تصريح ، امتياز ، فحص ، استكشاف ، تفتيش ، تحقيق ، مطاردة ، بحث ، التراخيص",
	},
	service_providers: {
		en: "archive, catalog, directory, inventory, prospectus, list, permits, licenses",
		ar: "الأرشيف ، كتالوج ، دليل ، جرد ، نشرة ، قائمة، التصاريح، التراخيص",
	},
	service_charge_index: {
		en: "indicator, ratio, basis, clue, guide, pointer, indicia, renting, lease, permits, licenses",
		ar: "مؤشر ، نسبة ، أساس ، دليل، التصاريح، التراخيص",
	},
	find_contract_usc: {
		en: "agent, dealer, entrepreneur, financial, intermediary, mediator, merchant, stockbroker, undertake, pledge, promise,  covenant, commit,  agreement, deal, permits, licenses",
		ar: "وكيل ، تاجر ، رجل أعمال ، مالي ، وسيط ، سمسار، تعهد، وعد، عهد، التزام، اتفاق، صفقة، التصاريح، التراخيص",
	},
	mollak_service_charges: {
		en: "account, bill, cost,  expense, pay, payment, price, wage, permits, licenses",
		ar: "حساب ، فاتورة ، تكلفة ، حساب ، دفع ، دفعه ، سعر ، أجر، التصاريح، التراخيص",
	},
	register_certificate: {
		en: "undertake, pledge, promise,  covenant, commit,  agreement, deal, renat, rental, lease, certificate, contract, record, enter, log, submit, file, permits, licenses",
		ar: " تعهد، وعد، عهد، التزام، اتفاق، صفقة، عقد، شهادة، إيجار، تأجير، سجل ، أدخل ، سجل ، أرسل ،  ملف، التصاريح، التراخيص",
	},
	print_certificate: {
		en: "Download, undertake, pledge, promise,  covenant, commit,  agreement, deal, renat, rental, lease, certificate, contract, record, enter, log, submit, file",
		ar: " تحميل، تعهد، وعد، عهد، التزام، اتفاق، صفقة، عقد، شهادة، إيجار، تأجير، سجل ، أدخل ، سجل ، أرسل ،  ملف",
	},
	who_is_managing: {
		en: "company, firm, corporation, association, Office, offices, management, administration, department, running, conduct, direction,  permits, licenses",
		ar: "شركة ، جمعية ، مؤسسة ، مكتب ، مكاتب ، إدارة ، تشغيل ، سلوك ، اتجاه، التصاريح، التراخيص",
	},
	/* RDC */
	regi_case: {
		en: "record, enter, log, submit, file, issue, case, cause, question, matter, affair",
		ar: " سجل ، أدخل ، سجل ، أرسل ،  ملف ، السبب ، السؤال ، المسألة ، القضية",
	},
	view_case: {
		en: "case, cause, question, matter, affair, see, view, sight",
		ar: "السبب ، السؤال ، المسألة ، القضية ، انظر ، عرض ، مشهد",
	},
	rdc_cert: {
		en: "behavior, conduct, attitude, demeanor, action, manner, authorization, certificate, charter, permit, privilege, examination",
		ar: "السلوك ، إذن ، شهادة ، ميثاق ، تصريح ، امتياز ، فحص ، استكشاف ، تفتيش ، تحقيق",
	},
	smart_judge: {
		en: "intelligent, smart, clever, bright, brilliant, brainy",
		ar: "قاضي، قضاء، تقاضي، ذكي",
	},
	track_case: {
		en: "case, cause, question, matter, affair, pursuit, chase, tracking",
		ar: "السبب ، السؤال ، المسألة ، القضية ، السعي ، مطاردة ، تتبع",
	},
	ques_ans: {
		en: "",
		ar: "",
	},
	rdc_services: {
		en: "",
		ar: "",
	},
	queue_request: {
		en: "",
		ar: "",
	},
	/* My Requests*/
	loss_cert: {
		en: "loss, damage, wastage, injury, disadvantage,certificate, certification, testimony, degree, diploma, witness",
		ar: "فقدان ، تلف ، هدر ، إصابة ، عيب، شهادة، وثيقة، صك، عقد",
	},
	site_plan: {
		en: "site, location, position, place, scene, spot, map, chart, plan, card, carte, issue, release, export, publish, put out, emit",
		ar: "موقع ، مكان ، بقعة ، خريطة ، مخطط ، خطة ، إصدار ، الافراج ، تصدير ، نشر",
	},
	prop_valuation: {
		en: "condition, position, state, assessment, cost, estimate, estimation, worth",
		ar: "الشرط ، الموقف ، حالة، تقدير ، تكلفة ، تقييم ، قيمة",
	},
	mortgage_quotation: {
		en: "mortgage, pledge, value, worth, amount, price, rate, account",
		ar: "الرهن العقاري ، تعهد ، رهن ، القيمة ، المبلغ ، السعر ، الحساب",
	},
	my_sell_requests: {
		en: "",
		ar: "",
	},
	third_party_valuation: {
		en: "guess, speculation, estimate, valuation, assessment, estimation , pricing",
		ar: "تخمين ، المضاربة ، تقدير ، التسعير",
	},
	register_certificate_request: {
		en: "Rent, Rental, Certificate, Contract, request, order",
		ar: "إيجار ، تأجير، شهادة ، عقد ، طلب",
	},
	rvs_complaints: {
		en: "violation, breach, contravention, infringement, infraction, transgression, complaint, invasion, encroachment, assault, offensive, battery, wrong, wrongdoing, rvs",
		ar: "تعدي ، خرق ، مخالفة ، اعتداء ، ، خطأ ، ظلم، رفع شكوى ، شكاوى ، شكوى ، انتهاك",
	},
	/*REIP*/
	sim: {
		en: "investment, exploitation, operation, development, placement, placing, map, chart, plan",
		ar: "الاستثمار ، والاستغلال ، والتشغيل ، والتنمية ، والتنسيب ، الخريطة ، الرسم البياني ، الخطة",
	},
	/*Service Directory Sub services*/
	valuation_companies: {
		en: "guess, speculation, estimate, valuation, assessment, estimation , pricing, company, firm, corporation, association, Office, offices",
		ar: "تخمين ، المضاربة ، تقدير ، التسعير ، شركة ، جمعية ، مؤسسة ، مكتب ، مكاتب",
	},
	management_companies: {
		en: "company, firm, corporation, association, Office, offices, management, administration, department, running, conduct, direction",
		ar: "شركة ، جمعية ، مؤسسة ، مكتب ، مكاتب ، إدارة ، تشغيل ، سلوك ، اتجاه",
	},
	property_trustees: {
		en: "company, firm, corporation, association, Office, offices,",
		ar: "شركة ، جمعية ، مؤسسة ، مكتب ، مكاتب ،",
	},
	rt_offices_map: {
		en: "company, firm, corporation, association, Office, offices,",
		ar: "شركة ، جمعية ، مؤسسة ، مكتب ، مكاتب ،",
	},
	approved_dev: {
		en: "company, firm, corporation, association, Office, offices,contractor, entrepreneur, undertaker, promoter, provider, developer",
		ar: "شركة ، جمعية ، مؤسسة ، مكتب ، مكاتب ، المقاول ، منظم ، متعهد ، المروج ، مزود ، المطور",
	},
	mortgage_consultancy: {
		en: "",
		ar: "",
	},
	real_state_consultancy: {
		en: "",
		ar: "",
	},
	owners_association: {
		en: "company, firm, corporation, association, Office, offices,association, society, assembly, organization, meeting, institution, owner, holder, proprietor, possessor",
		ar: "شركة ، جمعية ، مؤسسة ، مكتب ، مكاتب ،  مجتمع،  تنظيم، اجتماع، مؤسسة، مالك ، ملاك ،صاحب",
	},
	auditors: {
		en: "audit, auditing, examination",
		ar: "تدقيق حسابات, فحص الحسابات, بيان نهائي",
	},
	broker_offices: {
		en: "broker, jobber, middleman, speculator",
		ar: "وسيط ، عامل ، وسيط ، مضارب",
	},
	escrow_accounts: {
		en: "Approved Survey Companies registered with RERA with a valid license.",
		ar: "الائتمان ، الثقة ، حساب",
	},
	survey_companies: {
		en: "survey, scanning, wipe, wiping, cadastre, mopping",
		ar: "مسح، شركة، خارطة",
	},
	rt_office_transaction_requests: {
		en: "office, offices, registration",
		ar: "مكاتب ، مكاتب ، حساب",
	},
	tasken: {
		en: "Investor, owners, million, value, visa, residency, Taskeen",
		ar: "مستثمر ، مالك ، مليون ، قيمة ، تأشيرة ، إقامة ، تسكين",
	},
	rental_valuation: {
		en: "condition, position, state, assessment, cost, estimate, estimation, worth, rent, rental, lease",
		ar: "الشرط ، الموقف ، حالة، تقدير ، تكلفة ، تقييم ، قيمة، ايجار، تأجير",
	},
	verify_green_list: {
		en: "member, party, validate, verify, Broker, Mediator, green, list",
		ar: "عضو ، طرف ، تحقق ، وسيط ، أخضر ، قائمة، خضراء",
	},
	raise_a_complaint_public: {
		en: "violation, breach, contravention, infringement, infraction, transgression, complaint, invasion, encroachment, assault, offensive, battery, wrong, wrongdoing, rvs",
		ar: "تعدي ، خرق ، مخالفة ، اعتداء ، ، خطأ ، ظلم، رفع شكوى ، شكاوى ، شكوى ، انتهاك",
	},
	faqs: {
		en: "FAQs, FAQ, Help, Assistance, Frequently Asked Questions, questions",
		ar: "الأسئلة الاكثر تكراراً، السؤال الاكثر تكراراً، مساعدة، طلب مساعدة، الأسئلة الاكثر تكراراً، الأسئلة",
	},
};
